import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export type ViewBy = "summary" | "water_class" | "level0wrs";

/** What each grouping is called, in the switch's order. */
export const useViewByLabels = (): Record<ViewBy, string> => {
  const { t } = useTranslation();

  return {
    summary: t("common.summary"),
    water_class: t("water_class.water_class_header"),
    level0wrs: t("common.level0wrs"),
  };
};

/** Toggle buttons, under a visible "View by" label, choosing how a widget groups its volumes. */
const ViewBySwitch: React.FunctionComponent<{
  value: ViewBy;
  onChange: (value: ViewBy) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const labels = useViewByLabels();

  return (
    <fieldset>
      <legend className="mb-1 text-sm leading-6 text-gray-700">
        {t("common.view_by")}
      </legend>
      <div className="inline-flex rounded border border-gray-200 bg-white p-0.5 text-xs font-semibold">
        {(Object.keys(labels) as ViewBy[]).map(option => (
          <button
            key={option}
            type="button"
            aria-pressed={option === value}
            onClick={() => onChange(option)}
            className={classNames(
              "rounded px-2.5 py-1",
              option === value
                ? "bg-primary-1 text-white"
                : "text-gray-600 hover:bg-gray-100",
            )}
          >
            {labels[option]}
          </button>
        ))}
      </div>
    </fieldset>
  );
};

export default ViewBySwitch;
